/* assets/booklist-school-info.js
   Central configuration for the Booklist Finder page.
   - Add schools here
   - Add per-yeargroup notes here
*/
(function () {
  const LISTS = {
    ListA: { title: "List A", subtitle: "Required items" },
    ListB: { title: "List B", subtitle: "Optional / only if you don’t already have them" },
    Music: { title: "Music", subtitle: "Only if applicable for your year group" }
  };

  const stBListBNote = "Only purchase these items if you do not have them from a previous year.";

  window.BooklistSchoolInfo = {
    version: 1,
    lists: LISTS,

    // Keys here should match <option value="..."> in your school dropdown
    schools: {
      brightonstateschool: {
        label: "Brighton State School",
        collectionHandle: "bookpacks-brighton",
        // If you still want tag filtering, set schoolTag to the exact tag used on products (optional)
        schoolTag: "brightonstateschool",
        yeargroups: [
          { value: "prep", label: "Prep Year" },
          { value: "year1", label: "Year 1" },
          { value: "year2", label: "Year 2" },
          { value: "year3", label: "Year 3" },
          { value: "year3/4", label: "Year 3/4" },
          { value: "year4", label: "Year 4" },
          { value: "year4/5", label: "Year 4/5" },
          { value: "year5", label: "Year 5" },
          { value: "year5/6", label: "Year 5/6" },
          { value: "year6", label: "Year 6" }
        ]
      },

      yugumbirstateschool: {
        label: "Yugumbir State School",
        collectionHandle: "bookpacks-yugumbir",
        schoolTag: "yugumbirstateschool",
        yeargroups: [
          { value: "prep", label: "Prep Year" },
          { value: "year1", label: "Year 1" },
          { value: "year2", label: "Year 2" },
          { value: "year3", label: "Year 3" },
          { value: "year4", label: "Year 4" },
          { value: "year5", label: "Year 5" },
          { value: "year6", label: "Year 6" }
        ]
      },

      // NEW SCHOOL
      stbernardinesschoolregentspark: {
        label: "St. Bernardine's Catholic School - Regent Park",
        collectionHandle: "bookpacks-stbernardines",
        // Your product tag you told me you’re using for this school:
        schoolTag: "St.BernardinesSchoolRegentsPark",
        yeargroups: [
          { value: "prep", label: "Prep Year" },
          { value: "year1", label: "Year 1" },
          { value: "year2", label: "Year 2" },
          { value: "year3", label: "Year 3" },
          { value: "year4", label: "Year 4" },
          { value: "year5", label: "Year 5" },
          { value: "year6", label: "Year 6" }
        ],

        // Per-yeargroup “extra info” shown ABOVE the lists
        yeargroupInfo: {
          prep: {
            ListA: {
              additionalItemsRequired: ["2 x boxes of tissues", "1 x packet of baby wipes"],
              pleaseDoNotBring: ["Novelty erasers", "Novelty pencils", "Liquid paper"],
              notes: [
                "No removable book covers (contact is ok).",
                "Name all books and folders but not stationery items as they are shared."
              ]
            }
          },

          year1: {
            ListA: {
              additionalItemsRequired: ["2 x boxes of tissues", "1 x packet of baby wipes"],
              pleaseDoNotBring: ["Novelty erasers", "Novelty pencils", "Liquid paper", "Pencil cases (not required)"],
              notes: ["Please name all books and folders but not stationery items as they are shared."]
            },
            ListB: { note: stBListBNote }
          },

          year2: {
            ListA: {
              additionalItemsRequired: ["1 x packet Chux cloths", "2 x boxes of tissues"],
              pleaseDoNotBring: ["Novelty erasers", "Novelty pencils", "Liquid paper", "Pencil cases (not required)"]
            },
            ListB: { note: stBListBNote }
          },

          year3: {
            ListA: {
              additionalItemsRequired: ["2 x boxes of tissues", "1 x packet Chux cloths"],
              pleaseDoNotBring: ["Novelty erasers", "Novelty pencils", "Liquid paper"]
            },
            ListB: { note: stBListBNote }
          },

          year4: {
            ListB: { note: stBListBNote }
          },

          year5: {
            ListA: {
              additionalItemsRequired: ["3 x boxes of tissues"],
              pleaseDoNotBring: ["Novelty erasers", "Novelty pencils", "Liquid paper"]
            },
            ListB: { note: stBListBNote }
          },

          year6: {
            ListA: {
              additionalItemsRequired: ["3 x boxes of tissues"],
              pleaseDoNotBring: ["Novelty erasers", "Novelty pencils", "Liquid paper", "Flexible rulers"]
            },
            ListB: { note: stBListBNote }
          }
        }
      }
    }
  };
})();
